import apiClient from './apiClient.js';
import * as utils from '../utils/utils.js';

export const fetchGatheringsByOwner = async (owner_id) => {
    const server_url = `/gatherings_by_owner`;

    try {
        const response = await apiClient.post(server_url, {
            owner_id: owner_id,
        });

        const gatherings = response.data.gatherings;
        const orderedGatherings = utils.sortByName(gatherings);
        return orderedGatherings;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};

export const fetchAllGatheringsForParticipants = async (participantIds) => {
    const server_url = `/gatherings_by_participants`;

    try {
        const response = await apiClient.post(server_url, {
            participant_ids: participantIds,
        });

        const gatherings = response.data.gatherings;
        const orderedGatherings = utils.sortByName(gatherings);
        return orderedGatherings;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};

export const fetchGatheringById = async (gathering_id) => {
    const server_url = `/gathering`;

    try {
        const response = await apiClient.get(server_url, {
            params: { gathering_id },
        });

        return response.data.gathering;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};

export const fetchGatheringEvents = async (gathering_id) => {
    const server_url = `/gathering/events`;

    try {
        const response = await apiClient.get(server_url, {
            params: { gathering_id },
        });

        return response.data.events;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};

export const fetchGatheringParticipants = async (gathering_id) => {
    const server_url = `/gathering/participants`;

    try {
        const response = await apiClient.get(server_url, {
            params: { gathering_id },
        });

        return response.data.participants;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};

export const fetchGatheringStats = async (gathering_id) => {
    const server_url = `/gathering/stats`;

    try {
        const response = await apiClient.get(server_url, {
            params: { gathering_id },
        });

        return response.data.stats;
    } catch (err) {
        console.log(err.message);
        console.log(err.response);
        throw err;
    }
};
